import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PasswordDialog } from "@/components/PasswordDialog";
import HomePage from "@/pages/HomePage";
import AddRecipePage from "@/pages/AddRecipePage";
import RecipeDetailPage from "@/pages/RecipeDetailPage";
import EditRecipePage from "@/pages/EditRecipePage";
import SharedRecipePage from "@/pages/SharedRecipePage";
import { APP_VERSION } from "@/lib/version";

/** Global recovery dialog: any 401 from a non-public endpoint bumps the
 *  authPromptCounter in AuthContext, which pops this dialog. Per-page dialogs
 *  still handle the explicit "click Edit/Delete" → prompt flows. */
function GlobalAuthRecovery() {
  const { authPromptCounter } = useAuth();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (authPromptCounter > 0) setOpen(true);
  }, [authPromptCounter]);
  return <PasswordDialog open={open} onOpenChange={setOpen} />;
}

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-background">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/add" element={<AddRecipePage />} />
            <Route path="/recipe/:id" element={<RecipeDetailPage />} />
            <Route path="/recipe/:id/edit" element={<EditRecipePage />} />
            <Route path="/share/:token" element={<SharedRecipePage />} />
          </Routes>
          <GlobalAuthRecovery />
        </BrowserRouter>
        <div
          className="fixed bottom-2 left-2 z-40 rounded-full bg-background/70 backdrop-blur-sm px-2 py-0.5 text-[10px] text-muted-foreground border border-border/50 pointer-events-none select-none"
          aria-label="App version"
        >
          v{APP_VERSION}
        </div>
        <Toaster position="bottom-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
